import KyMethod from "../repositories/KyMethod"

export default class MiscRepo extends KyMethod {
  protected async getRawUniversities() {
    return this._getData("/university")
  }

  protected async getRawTestimonials(type: string) {
    return this._getData(`/testimonials`, { type }, "v3")
  }

  protected async getRawTags(type: string) {
    return this._getData(`/tags`, { type })
  }

  protected async getRawOrderAndAlumnus() {
    return this._getData(`/users/orders-alumni`, {}, "v3")
  }

  async getRawProducts(query?: any) {
    return this._getData("/digital/products", query)
  }
}
